import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Shared/Button/Button';
import { GoogleIcon } from '../../icons/Google.icon';

type Props = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
};

export const GoogleButton = ({ onClick, disabled }: Props) => {
  const { t } = useTranslation(['entry']);

  return (
    <Button
      type="button"
      variant="secondary"
      size="lg"
      onClick={onClick}
      disabled={disabled}
      className="w-full gap-3 font-medium"
    >
      <GoogleIcon className="h-5 w-5" />
      <span>{t('continue_with', { value: 'Google' })}</span>
    </Button>
  );
};
